// fetchLivestreamFundingDetail.js
'use strict';

import getMeData from '../selector/getMeData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';

import handleRealtimeEvent from '../action/handleRealtimeEvent.js';

import fetch from '../resource/customFetch.js';
import { API_V2 } from '../resource/resourceUrlTypeConstants.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';
import { RealtimeEvent } from '../resource/realtimeConstants.js';

import {
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch livestream funding detail
 * @kind action
 * @param {object} options - action options.
 * @param {string} options.streamId - stream id.
 * @param {string} options.runningShowId - livestream running show id.
 * @return {Promise} Action promise.
 * @see https://api-v2.swag.live/docs#/livestream/get_session_funding_details_sessions__session_id__funding__goal_id__get
 */
const fetchLivestreamFundingDetail =
  ({ streamId, runningShowId } = {}) =>
  async (dispatch, getState) => {
    const networkingSelectPath = [
      'fetch',
      'livestream',
      streamId,
      'fundingDetail',
      runningShowId,
    ];
    const sessionId = getLiveStreamData(getState(), [streamId], 'sessionId');

    if (!streamId || !sessionId || !runningShowId)
      return dispatch({ type: '' });

    const token = getMeData(getState(), 'token');

    const fetchOptions = {
      method: 'GET',
      headers: {
        ...getHeaders(),
      },
    };

    if (token) {
      fetchOptions.headers.Authorization = `Bearer ${token}`;
    }

    const fetchUrl = getResourceUrl({
      endpoint: `/sessions/${sessionId}/funding/${runningShowId}`,
      resourceType: API_V2,
    });

    dispatch({
      type: SET_NETWORKING_FETCHING,
      payload: { selectPath: networkingSelectPath },
    });
    try {
      let response = await fetch(fetchUrl.href, fetchOptions);

      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl,
        });
      }

      const data = (await response.json()) || {};

      dispatch(
        handleRealtimeEvent({
          id: streamId,
          event: RealtimeEvent.LIVESTREAM_SHOW_FUNDING_UPDATED,
          data,
        })
      );
      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath: networkingSelectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath: networkingSelectPath, error },
      });
    }
  };

export default fetchLivestreamFundingDetail;
